var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
var android = /android/.test(navigator.userAgent.toLowerCase());
var safari = /^((?!chrome).)*safari/i.test(navigator.userAgent);

var tem, M = navigator.userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

$(document).ready(function () {
    if (iOS || android)
        $('body').addClass('mobile');

    if (iOS) {
        $('body').addClass('ios');
    }
    else if (android) {
        $('body').addClass('android');
    }

    if (safari) {
        $('body').addClass('safari');

        var ver = '';
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = navigator.userAgent.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
        if (M[0].toLowerCase() === 'safari') {
            ver = M[1];
        }

        if (ver !== '') {
            if (parseInt(ver) > 8)
                $('body').addClass('gt8');
            else
                $('body').addClass('let8');
        }
    }
});